<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div
      v-for="(option, value) in selected"
      :key="value"
      :class="{ 'is-invalid': hasErrors }"
      class="custom-control custom-checkbox"
    >
      <input
        class="custom-control-input"
        type="checkbox"
        :id="attribute.name + option.index"
        v-model="option.selected"
        @change="emitChange"
      />
      <label class="custom-control-label" :for="attribute.name + option.index">
        {{ option.value }}
      </label>
    </div>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  created () {
    this.attribute.options.forEach((option, index) => {
      const obj = {
        selected: this.value !== null && this.value.includes(option),
        value: option,
        index,
      }
      this.$emit('input', this.selection());
      return this.selected.push(obj);
    });
  },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    emitChange() {
      this.$emit('input', this.selection());
    },
    selection() {
      return JSON.stringify(this.selected.reduce((accumulator, select) => {
        if (select.selected) {
          accumulator.push(select.index);
        }
        return accumulator;
      }, []));
    }
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    }
  }
}
</script>
